module.exports = __webpack_public_path__ + "static/img/login.0c3148b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/login.png
// module id = j0X5
// module chunks = 1